import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Languages } from 'lucide-react';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'de' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      data-testid="language-toggle-button"
      onClick={toggleLanguage}
      variant="outline"
      size="sm"
      className="gap-2"
    >
      <Languages className="h-4 w-4" />
      {i18n.language === 'en' ? '🇬🇧' : '🇩🇪'}
    </Button>
  );
};

export default LanguageToggle;